import { render, staticRenderFns } from "./downlists.vue?vue&type=template&id=1bb42e8c&scoped=true"
import script from "./downlists.vue?vue&type=script&lang=js"
export * from "./downlists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb42e8c",
  null
  
)

export default component.exports